import React, { Component } from 'react';
import './index.scss';
import Layover from '../DetailsPane/BlockOverlay';

class Report extends Component {
  constructor(props) {
    super(props);
    this.state={
      overlayVisibility:false
    }
  }

  closeOverlay = () =>{
      this.setState({
        overlayVisibility:false
      })
  }
  componentDidMount(){
    // this.props.getBlockUser(this.props.selectedConversation.bzId)
  }
  openOverlay = () =>{
    this.setState({
      overlayVisibility:true
    })
  }
  // selectedConversation={conversations.conversations[0]}
  // auth = {auth}
  // business ={business}
  // erorReport = {this.props.postErrorReport}
  // errorData = {this.props.conversations}
  // clearReportFlags ={this.props.clearReportFlags}

  render(){
  const { overlayVisibility } = this.state;
  return (
    <div className="report">
      <div className="error-report" onClick={this.openOverlay}>
        <div><i className="material-icons">remove_circle</i><span>Block number</span></div>
      </div>
      <Layover 
          setblockOverlayVisibility={this.closeOverlay} 
          modelopen={overlayVisibility} 
          name={''}
          phone={''}
          selectedConversation = {this.props.selectedConversation}
          auth ={this.props.auth}
          business = {this.props.business}
          blockUser ={this.props.blockUser}
          getBlockUser = {this.props.getBlockUser}
          errorData= {this.props.errorData}
          clearReportFlags ={this.props.clearReportFlags}
          globalReport = {true}
          selectedLocation={this.props.selectedLocation}
      />
    </div>
  );
  }
  
};

export default Report;
